import { render, staticRenderFns } from "./skuIE.vue?vue&type=template&id=25a9455a&"
import script from "./skuIE.vue?vue&type=script&lang=js&"
export * from "./skuIE.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports